import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import dayOfYear from "dayjs/plugin/dayOfYear";

dayjs.locale("en-gb");
dayjs.extend(dayOfYear);

export const getDayOptions = (daysBack = 7, daysForward = 1, disableFutureDates = false) => {
    const options = [];
    const endDay = dayjs().add(daysForward, "day");
    let iteratorDay = dayjs().subtract(daysBack, "day");

    while (iteratorDay.isBefore(endDay)) {
        options.push({
            text: iteratorDay.format("DD MMMM"),
            value: iteratorDay.format("YYYY-MM-DD"),
            disabled: disableFutureDates && iteratorDay.isAfter(dayjs()),
        });

        iteratorDay = iteratorDay.add(1, "day");
    }

    return options;
};

export const julianCode2Dayjs = (julianCode) => {
    const source = dayjs(julianCode);
    const dayOfYear = source.dayOfYear();
    const julianDate = dayjs().dayOfYear(dayOfYear);

    return julianDate;
};

export const julianCode2packingDate = (julianCode) => {
    const julianDate = julianCode2Dayjs(julianCode);
    return julianDate.format("YYYY-MM-DD");
};

export const packingDate2JulianCode = (packingDate) => {
    const julianDate = dayjs(packingDate);
    return julianDate.dayOfYear();
};

export const fruitAge2Date = (fruitAge) => {
    return dayjs().subtract(fruitAge, "day").format("YYYY-MM-DD");
};

export const date2FruitAge = (date) => {
    return dayjs().diff(dayjs(date), "day");
};
